module.exports = __webpack_public_path__ + "static/media/pic3@2x.f4a25b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/pic3@2x.png
// module id = 1415
// module chunks = 0